<template>
  <div id="app">
    <template v-if="!$route.meta.isShare">
      <div v-if="!isMobile">
<!--      <router-view></router-view>-->
        <qk-header v-if="showLayout && isRouterAlive"/>
        <div style="min-height: calc(100vh - 430px)">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"/>
        </div>
        <!--在线咨询-->
        <qk-service v-show="showService"/>
        <qk-footer v-if="showLayout"/>
      </div>
      <div v-else>
        <qk-header-phone v-if="showLayout && isRouterAlive"/>
        <keep-alive>
          <router-view  v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view  v-if="!$route.meta.keepAlive"/>
        <qk-service1 v-show="showService"/>
        <qk-footer v-if="showLayout"/>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
    <PopupServerAgreement />
  </div>
</template>

<script>
import PopupServerAgreement from '@/components/PopupServerAgreement'
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  components: { PopupServerAgreement },
  data () {
    return {
      showLayout: true,
      isRouterAlive: true,
      isMobile: false,
      showService: true
    }
  },
  created() {
    this.layoutVisible(this.$route.path)
    this.serviceVisible(this.$route.path)

    if (navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )) {
      this.isMobile = true
    }
    // this.isMobile = this.$route.query.meta.isMobile
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    layoutVisible (path) {
      this.showLayout = path !== '/login'
    },
    serviceVisible (path) {
      this.showService = !(path === '/login' || path === '/register' || path === '/reset' || path === '/sanger');
    }
  },
  watch: {
    $route (to, from) {
      this.layoutVisible(to.path)
      this.serviceVisible(to.path)
      // this.isMobile = to.meta.isMobile
    },
  }
}
</script>

<style>
.index-gray {
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); 
  -webkit-filter: grayscale(100%);
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}
 ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 8px;
  height: 8px;
}
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}
::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.15);
  transition: color 0.2s ease;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

@media screen and (max-width: 641px){
  .wrap-tec .breads{
    display: none!important;
  }
}
@media screen and (max-height: 800px){
  #udesk_btn a{
    top: 63vh!important;
  }
  .online-service{
    top: 63vh!important;
  }
}
@media screen and (max-width: 1440px) and (min-width: 1400px){
  #udesk_btn a{
    top: 68vh!important;
  }
  .online-service{
    top: 68vh!important;
  }
}
@media screen and (max-width: 1366px) and (min-width: 1360px){
  #udesk_btn a{
    top: 60vh!important;
  }
  .online-service{
    top: 60vh!important;
  }
}
@media screen and (max-width: 1280px) and (min-width: 1270px){
  #udesk_btn a{
    top: 73vh;
  }
  .online-service{
    top: 73vh;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue